<template>
  <section class="social-article">
    <div class="social-article__line"></div>
    <div class="social-article__social">
      <a href="#" @click="facebookShare">
        <span class="social-article__fb">
          <i class="icon-facebook"></i>
          <span class="social-article__text">Podziel się</span>
        </span>
      </a>
      <a href="#" @click="twitterShare">
        <span class="social-article__tweeter">
          <i class="icon-twitter"></i>
          <span class="social-article__text">Tweetnij</span>
        </span>
      </a>
      <a :href="`mailto:?subject=${title}&body=${shareUrl}`">
        <span class="social-article__mail">
          <i class="icon-mail-alt"></i>
          <span class="social-article__text">Wyślij</span>
        </span>
      </a>
      <a
        href="https://news.google.com/publications/CAAqBwgKMPOWmAsw-sCvAw?ceid=PL:pl&amp;oc=3&amp;hl=pl&amp;gl=PL"
        target="_blank"
      >
        <span class="social-article__google">
          <i class="icon-google"></i>
          <span class="social-article__text">Google News</span>
        </span>
      </a>
    </div>

    <template v-if="isCommentBox">
      <div class="social-article__comments" @click="hideComments">
        <div class="social-article__comment-box"><i class="icon-comment"></i>Skomentuj</div>
      </div>
      <Transition>
        <div
          v-if="!fbHide"
          class="fb-comments"
          :data-href="url"
          data-width="100%"
          allowTransparency="false"
        />
      </Transition>
    </template>
  </section>
</template>

<script setup>
import { computed, nextTick, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  shareUrl: {
    type: String,
    default: ''
  },
  isCommentBox: {
    type: Boolean,
    default: false
  }
})

const url = computed(() => window.location.href)

const fbHide = ref(true)
const hideComments = () => {
  fbHide.value = !fbHide.value
}

const facebookShare = () => {
  const url = `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`
  const options =
    'toolbar=no, scrollbars=yes, resizable=yes, top=500, left=500, width=600, height=500'
  window.open(url, '_blank', options)
}

const twitterShare = () => {
  const url = `https://twitter.com/share?url=${window.location.href}&text=${props.title}&hashtags=wieszwiecej`
  const options =
    'toolbar=no, scrollbars=yes, resizable=yes, top=500, left=500, width=600, height=500'
  window.open(url, '_blank', options)
}

const initFb = () => {
  if (!fbHide.value) {
    nextTick(() => {
      window.FB.XFBML.parse()
    })
  }
}

watch(
  () => route.fullPath,
  () => {
    initFb()
  },
  { immediate: true }
)

watch(
  () => fbHide.value,
  () => {
    initFb()
  },
  { immediate: true }
)
</script>

<style lang="scss">
@import '@/assets/scss/components/buttons/social-article.scss';
</style>
